// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"ResumeSentinelModal_buttonGroup__1RcaS","infoText":"ResumeSentinelModal_infoText__2zjEI"};